import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

interface MovieCardProps {
  movie: MovieItem;
  size?: 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-xl bg-background-100 mb-3 ${
        size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'
      }`}>
        <img
          src={movie.coverImage}
          alt={movie.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
            {movie.quality}
          </span>
        </div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
            {movie.rating} 分
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3 pt-10">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <i className="ri-play-fill"></i>
            <span>{movie.playCount} 次播放</span>
          </div>
        </div>
      </div>
      <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {movie.title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{movie.year}</span>
        <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
        <span>{movie.region}</span>
        <span className="w-1 h-1 rounded-full bg-foreground-400 hidden sm:block"></span>
        <span className="hidden sm:inline">{movie.tags[0]}</span>
      </div>
    </Link>
  );
}